import { getRoute, postRoute } from "./client"

export interface AuthAccount {
  id: string
  email: string | null
  provider: "email" | "vk"
  displayName: string
  avatarUrl: string
  adminRole: "owner" | "moderator" | null
}

interface AuthResponse {
  success: boolean
  account: AuthAccount
  isNewAccount: boolean
}

export const authMeRoute = getRoute<{ account: AuthAccount | null }>("/api/auth/me")
export const requestEmailCodeRoute = postRoute<{ success: boolean; expiresIn: number }>("/api/auth/email/request")
export const verifyEmailCodeRoute = postRoute<AuthResponse>("/api/auth/email/verify")
export const vkAuthRoute = postRoute<AuthResponse>("/api/auth/vk")
export const logoutRoute = postRoute<{ success: boolean }>("/api/auth/logout")
